const { PHONE_CODES, CANADA_NPA_CODES, PHONE_CODES_ISO } = require('./constants');

export function phoneToString(phone, withExt) {
  if (typeof phone === 'string') {
    return phone;
  }
  const hasExt = phone && !!(phone.extension || '').trim();
  const ext = withExt && hasExt ? ` x${phone.extension || ''}` : '';
  return phone ? `${phone.countryCode} ${phone.phoneNumber}${ext}` : '';
}
export function phoneToStringV1(phone, withExt) {
  if (typeof phone === 'string') {
    return phone;
  }
  const hasExt = phone && !!(phone.extension || '').trim();
  const ext = withExt && hasExt ? ` x${phone.extension || ''}` : '';
  return phone
    ? `+${(phone.countryCode || '').replace(/-/g, '')}${(phone.phoneNumber || '').replace(/-/g, '')}${ext.replace(
        /-/g,
        ''
      )}`
    : '';
}

export function phoneCode(iso) {
  return PHONE_CODES[iso];
}

export function countryISO(phone) {
  if (phone.countryISO) {
    return phone.countryISO;
  }

  if (phone.countryCode === '1') {
    const NPACode = (phone.phoneNumber || '').substr(0, 3);
    return CANADA_NPA_CODES.includes(Number(NPACode)) ? 'CA' : 'US';
  }

  if (!phone.countryCode || phone.countryCode === 'USA') {
    phone.countryCode = '1';
    return 'US';
  }

  return PHONE_CODES_ISO[phone.countryCode] || phone.countryCode;
}

export function stringToPhone(source, phoneExt) {
  const phonePatterns = [
    {
      callback() {
        const match = source.trim().match(/([0-9\s]*)\(([^\)]+)\)([0-9-\s]+)[\s]*(ext\.[0-9\s]*|ext[0-9\s]*|)/i);
        if (match) {
          const [, countryCode, phoneNumber1, phoneNumber2, extension] = match;
          return {
            countryCode,
            phoneNumber: `${phoneNumber1 || ''}${phoneNumber2 || ''}`,
            extension: extension || phoneExt,
          };
        }
      },
    },
    {
      callback() {
        const match = source.trim().match(/([0-9]+)\s([0-9-\s]+)[\s]*(ext\.[0-9\s]*|ext[0-9\s]*|)/i);
        if (match) {
          const [, countryCode, phoneNumber, extension] = match;
          return {
            countryCode,
            phoneNumber,
            extension: extension || phoneExt,
          };
        }
      },
    },
    {
      callback() {
        const match = source.trim().match(/([0-9]+)-([0-9]+)-([0-9]+)-([0-9]+)[\s]*(ext\.[0-9\s]*|ext[0-9\s]*|)/i);
        if (match) {
          const [, countryCode, phoneNumber1, phoneNumber2, phoneNumber3, extension] = match;
          return {
            countryCode,
            phoneNumber: `${phoneNumber1 || ''}${phoneNumber2 || ''}${phoneNumber3 || ''}`,
            extension: extension || phoneExt,
          };
        }
      },
    },
    {
      callback() {
        const match = source.trim().match(/([0-9]+)-([0-9]+)-([0-9]+)[\s]*(ext\.[0-9\s]*|ext[0-9\s]*|)/i);
        if (match) {
          const [, phoneNumber1, phoneNumber2, phoneNumber3, extension] = match;
          return {
            phoneNumber: `${phoneNumber1 || ''}${phoneNumber2 || ''}${phoneNumber3 || ''}`,
            extension: extension || phoneExt,
          };
        }
      },
    },
    {
      callback() {
        const match = source.trim().match(/1([0-9]{10})[\s]*(ext\.[0-9\s]*|ext[0-9\s]*|)/i);
        if (match) {
          const [, phoneNumber, extension] = match;
          return {
            phoneNumber,
            extension: extension || phoneExt,
          };
        }
      },
    },
  ];
  for (let pattern of phonePatterns) {
    const phone = pattern.callback();
    if (phone) {
      const phoneNumber = phone.phoneNumber
        .trim()
        .replace(/[-\s]+/g, '')
        .replace(/([0-9]{3})([0-9]{3})([0-9]{4})/, '$1-$2-$3');
      return {
        source,
        countryCode: phone.countryCode || '1',
        phoneNumber,
        extension: (`${phone.extension || ''}`.match(/([0-9]+)/) || [])[0] || null,
      };
    }
  }
  return null;
}
